import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Link, Redirect, useParams } from "react-router-dom"
import "../src/ShippingData.css";
import { host, Host } from './App';
import { loadCustomers } from './Dashboard';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import real_l from "./real_logo.png";

//import { Customers } from './Dashboard';

function ShippingData() {
  var [del, setdel] = useState(1);
  var int = 4;
  var [postList, setPostList] = useState([]);
  var [PoNo, setPoNo] = useState({});
  var [poNo, setpoNo] = useState([]);
  var [PartNo, setPartNo] = useState({});
  var [Part_Desc, setPart_Desc] = useState({});
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState('2026-01-01');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var [customer, setCustomer] = useState({});
  const [comment, setComment] = useState({});
  var [ShippedQty, setShippedQty] = useState("");
  var [COMENTS, setComments] = useState("Comment");
  const [openorder, setopenorder] = useState("1");
  var [Customers, setCustomers] = useState([]);
  var [partNo, setpartNo] = useState([]);
  var [partDataset, setpartDataset] = useState([]);
  var User = JSON.parse(window.localStorage.getItem("Name"));
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const nowDate = new Date();
  const formattedDate = nowDate.toLocaleDateString();
  const formattedTime = nowDate.toLocaleTimeString();
  var [order, setOrder] = useState("1");
  var [test, setTest] = useState(int);

  // NEW: per-row edit state, keyed by `${PO_NO}_${PART_NO}`
  // Each entry only exists once the user actually types a value for that row.
  const [rowEdits, setRowEdits] = useState({});

  // NEW: role checking.
  // Shipped Qty / Actual Ship Date editing requires Admin AND Stage === '2'.
  // Comment editing requires Admin OR Harpreet Singh.
  const [isAdmin, setIsAdmin] = useState(false);
  const [userStage, setUserStage] = useState('');
  const [currentUserName, setCurrentUserName] = useState('');
  const canEditQtyDate = isAdmin && userStage === '2';
  const canEditComments = isAdmin || currentUserName === 'Harpreet Singh';

  // NEW: per-row comment edit state, keyed the same way as rowEdits
  const [commentEdits, setCommentEdits] = useState({});
  // NEW: which comment cell is currently hovered / focused, so it can
  // switch between plain read-only text and an editable textarea.
  const [hoveredCommentRow, setHoveredCommentRow] = useState(null);
  const [focusedCommentRow, setFocusedCommentRow] = useState(null);

  const getRowKey = (PO_NO, PART_NO) => `${PO_NO}_${PART_NO}`;

  const handleQtyChange = (PO_NO, PART_NO, value) => {
    // Allow only numbers (including empty string while typing/clearing)
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }
    const key = getRowKey(PO_NO, PART_NO);
    setRowEdits((prev) => ({
      ...prev,
      [key]: { ...prev[key], ShippedQty: value },
    }));
  };

  const handleActualShipDateChange = (PO_NO, PART_NO, value) => {
    const key = getRowKey(PO_NO, PART_NO);
    setRowEdits((prev) => ({
      ...prev,
      [key]: { ...prev[key], ActualShipdate: value },
    }));
  };

  // NEW: comment change handler
  const handleCommentChange = (PO_NO, PART_NO, value) => {
    const key = getRowKey(PO_NO, PART_NO);
    setCommentEdits((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  //var token = sessionStorage.getItem("token");
  var token = (window.localStorage.getItem("acessToken"));
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });

  // NEW: check the logged-in user's role/stage/name so we know whether to
  // show the Shipped Qty / Actual Ship Date inputs and the Comment editor.
  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const response = await Axios.get(`https://` + Host + `/api/user-info`, {
          params: { token }
        });
        if (response.data) {
          setIsAdmin(response.data.Ranked === 'Admin');
          setUserStage(response.data.Stage || '');
          setCurrentUserName(response.data.Name || '');
        }
      } catch (error) {
        console.error('Error checking user role:', error);
      }
    };
    checkUserRole();
  }, []);

  // quick refresh data
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/Shipping/search/${JSON.stringify(PoNo)},${JSON.stringify(PartNo)},${Postartdate},${Poenddate},${JSON.stringify(customer)},${order},${token},${JSON.stringify(Part_Desc)}`).then((data) => {
      setPostList(data.data)
    })
  }, [PoNo, PartNo, Postartdate, Poenddate, customer, order, del, Part_Desc])
  //to retreive po no
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/pono/${token}`).then((data) => {
      setpoNo(data.data)
    });
  }, [])
  // to retreive customers
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Customers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/partNo/${token}`).then((data) => {
      setpartNo(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/part_dataset/${token}`).then((data) => {
      setpartDataset(data.data)
    });
  }, [])
  // method to retrieve data combinely
  const search = () => {
    Axios.get(`https://` + Host + `/api/Shipping/search/${JSON.stringify(PoNo)},${JSON.stringify(PartNo)},${Postartdate},${Poenddate},${JSON.stringify(customer)},${order},${token},${JSON.stringify(Part_Desc)}`).then((data) => {
      setPostList(data.data)
    })
  }

  // Only sends the row that was actually clicked, and only if a real
  // shipped quantity was entered for it. Nothing is submitted from rows
  // the user never touched. Requires Admin AND Stage === '2' (enforced
  // on backend too - never trust the frontend gate alone).
  const Update = (val) => {
    if (!canEditQtyDate) {
      toast.error("You are not authorized to update Shipped Qty / Actual Ship Date.", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const key = getRowKey(val.PO_NO, val.PART_NO);
    const edit = rowEdits[key];
    const qty = edit?.ShippedQty;

    if (!qty || Number(qty) <= 0) {
      toast.error("Please enter a shipped quantity before updating.", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const actualShipDate = edit?.ActualShipdate || Date1.toISOString().slice(0, 10);

    // Key order here MUST match the column order in the backend's
    // INSERT INTO SHIPPED_DATA(...) VALUES (?) statement, since the
    // backend does Object.values(updateData) to build the params.
    const payload = {
      PO_NO: val.PO_NO,
      PART_NO: val.PART_NO,
      PO_SHIP_DATE: val.PO_SHIP_DATE.slice(0, 10),
      PART_DESCRIPTION: val.PART_DESCRIPTION,
      CUSTOMER: val.CUSTOMER,
      ACTUAL_SHIP_DATE: actualShipDate,
      QTY_SHIPPED: qty,
      COMMENTS: val.COMMENTS,
    };

    setdel(del = del + 1)
    Axios.post(`https://` + Host + `/api/Shippeddata/Updatetry`, { updateData: [payload], token: token })
      .then((response) => {
        if (response.status === 200) {
          // Clear only this row's edit state
          setRowEdits((prev) => {
            const copy = { ...prev };
            delete copy[key];
            return copy;
          });
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          });
          search();
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });
  };

  // NEW: auto-saves the comment as soon as the textarea loses focus.
  // Silently does nothing if nothing actually changed. Available to
  // Admin or Harpreet Singh (enforced on backend too).
  const UpdateComment = (val) => {
    if (!canEditComments) {
      return;
    }

    const key = getRowKey(val.PO_NO, val.PART_NO);
    const newComment = commentEdits[key];

    // Nothing typed, or unchanged from what's already saved - skip the call.
    if (newComment === undefined || newComment === (val.COMMENTS || "")) {
      return;
    }

    Axios.post(`https://` + Host + `/api/Shippeddata/UpdateComment`, {
      PO_NO: val.PO_NO,
      PART_NO: val.PART_NO,
      COMMENTS: newComment,
      token: token,
    })
      .then((response) => {
        if (response.status === 200) {
          setCommentEdits((prev) => {
            const copy = { ...prev };
            delete copy[key];
            return copy;
          });
          toast.success(response.data.message, {
            autoClose: 2000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '18px', borderRadius: '10px' },
          });
          search();
        }
      })
      .catch(function (error) {
        console.log(error.response);
        toast.error("Error updating comment.", {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const Delete = (PO_NO, PART_NO) => {
    setdel(del = del + 1)
    Axios.delete(`https://` + Host + `/api/Shippeddata/Delete/${PO_NO},${PART_NO},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 1000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
          });
          search();
        }
      })
      .catch(function (error) {
        console.log(error.response);
      });

  };
  const handlePrint = () => {

    const table = document.querySelector('#alldata');
    const printWindow = window.open("", "", "height=600,width=800");
    const img = document.createElement('img');
    img.src = real_l;

    printWindow.document.write(`
      <html>
        <head>
          <title></title>
          <style>
          h1 {
            display: inline-block;
            vertical-align: middle;
            margin: 0;
            text-align: center; /* Center the heading */
            width: 100%; /* Occupy the full width */
            font-family: Arial, sans-serif; /* Set the font family */
          }
          
          img {
            display: inline-block;
            height: 50px; /* Set the height of the image as required */
            margin-right: 10px; /* Set the spacing between the image and title as required */
          }
          
          table {
            border: 1px solid black;
            border-collapse: collapse;
            width: 100%;
            font-family: Arial, sans-serif; /* Set the font family */
          }
          
          th, td {
            border: 1px solid black;
            padding: 5px;
          }
          
          tr:nth-child(even) {
            background-color: #f2f2f2; /* Apply the table-striped style */
          }
          
          .bottom-right {
            position:relative;
            bottom: 10px;
            right: 10px;
            font-family: Arial, sans-serif; /* Set the font family */
          }
          </style>
        </head>
        <body>
  
          <h1>${img.outerHTML} </h1>
          <table class="table table-striped">${(table.innerHTML)}</table>
          <p class="bottom-right">Printed By: ${User}</p>
          <p class="bottom-right">Date Created: ${formattedDate + '  ' + formattedTime}</p>
        </body>

      </html>`
    );
    printWindow.document.querySelector('title').insertAdjacentHTML('afterbegin', `  
    `);
    printWindow.document.close();
    printWindow.focus();
  };
  return (
    <div className="MainPage_data">
      <div class="Container">
        <ToastContainer />
        <div class="row">
          <div class="col">
            <div class="row">
              {/* Grab the particular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='PO NO' list="PoNo" onChange={(e) => {
                setPoNo(e.target.value)
              }} onSelect={search} />
              <datalist id="PoNo">
                <option></option>
                {poNo.map(x => {
                  return <option>{x.PO_NO}</option>
                })}
              </datalist>
            </div>
            {canEditQtyDate ? (
              <div class="row">

                <div class="col">
                  <Link to="/UpdatePOData">
                    <input
                      type="button"
                      class="btn btn-success"
                      defaultValue="Update PO Data"
                      name="Section"
                      id="btn"
                    />
                  </Link>
                </div>
                <div class="col">
                  <Link to="/RGA/Return_Parts">
                    <input type="button" class="btn btn-success" defaultValue="Add Return" />
                  </Link>
                </div>

              </div>
            ) : null}
          </div>
          <div class="col">
            <div className='row'>
              {/* Grab the particular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='PART NO' list="PartNo" onChange={(e) => {
                setPartNo(e.target.value)
              }} onSelect={search} />
              <datalist id="PartNo">
                <option></option>
                {partNo.map(x => {
                  return <option>{x.Part_No}</option>
                })}
              </datalist>
            </div>
            <div className='row'>
              {/* Grab the particular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='PART DESCRIPTION' list="Partdesc" onChange={(e) => {
                setPart_Desc(e.target.value);
              }} onSelect={search} />
              <datalist id="Partdesc">
                <option></option>
                {partDataset.map(x => {
                  return <option>{x.Part_Description}</option>
                })}
              </datalist>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col" id='moldng'>
                {/* Grab the particular dates */}
                <input type='date' class="form-control form-rounded" placeholder='PO SHIP DATE' defaultValue={Postartdate} onChange={(e) => {
                  setPoStartdate(e.target.value)
                }} onSelect={search} />
                {/*<button class="btn btn-success" onClick={dates}>Submit</button > */}
                <span class="tooltiptext">Filter By PO SHIP DATE </span>

              </div>
              <div class="col">
                <input type='date' class="form-control form-rounded" placeholder='Operator' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
                  setPoEnddate(e.target.value)
                }} onSelect={search} />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <button className="btn btn-primary" onClick={handlePrint}>Print Table</button>
              </div>
              <div class="col">

              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              {/* Grab the particular Customer */}
              <input type='text' class="form-control form-rounded" placeholder='Customer' list='Customers' onChange={(e) => {
                setCustomer(e.target.value)
              }} onSelect={search} />
              <datalist id="Customers">
                <option></option>
                {Customers.map(x => {
                  return <option>{x.Customer}</option>
                })}
              </datalist>
            </div>
            <div class="row">
              <select
                type="select"
                class="form-control form-rounded"
                id="order"
                name="order"
                onChange={(e) => {
                  setOrder(e.target.value);
                  order = e.target.value;
                  search();
                }}
              >
                <option value="1">Open Orders</option>
                <option value="0"> Open/Closed Orders</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <Link to="/shippedparts">
                <input
                  type="button"
                  class="btn btn-success"
                  defaultValue="Review Shipped Data"
                  name="Section"
                  id="btn"
                />
              </Link>
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <div id="Shipping_table">
          <table class="table table-bordered" >
            <thead>
              <tr>
                <th>PO NO</th>
                <th>PART NO</th>
                <th>PO SHIP DATE</th>
                <th>PART DESCRIPTION</th>
                <th>CUSTOMER</th>
                <th>PO QTY</th>
                <th>REMAINED QTY</th>
                <th>ORDER DATE</th>
                <th>ACTUAL SHIP DATE</th>
                <th>SHIPPED QTY</th>
                <th id="comment">COMMENTS </th>
                <th>Update</th>
                <th>Delete</th>
              </tr>
            </thead>

            {
              postList.map((val, key) => {
                const rowKey = getRowKey(val.PO_NO, val.PART_NO);
                const rowEdit = rowEdits[rowKey] || {};
                const commentEdit = commentEdits[rowKey];
                const isCommentEditing = hoveredCommentRow === rowKey || focusedCommentRow === rowKey;
                return (
                  <tbody>
                    <tr key={key}>
                      <td>{val.PO_NO}</td>
                      <td>{val.PART_NO}</td>
                      <td>{(val.PO_SHIP_DATE).slice(0, 10)}</td>
                      <td>{val.PART_DESCRIPTION}</td>
                      <td>{val.CUSTOMER}</td>
                      <td>{val.QTY}</td>
                      <td>{val.Remained_parts}</td>
                      <td>{(val.PO_DATE).slice(0, 10)}</td>
                      <td>
                        {canEditQtyDate ? (
                          <input
                            type="date"
                            class="form-control form-rounded"
                            value={rowEdit.ActualShipdate || Date1.toISOString().slice(0, 10)}
                            onChange={(e) => {
                              handleActualShipDateChange(val.PO_NO, val.PART_NO, e.target.value)
                            }}
                          />
                        ) : (
                          val.ACTUAL_SHIP_DATE ? (val.ACTUAL_SHIP_DATE).slice(0, 10) : '-'
                        )}
                      </td>
                      <td>
                        {canEditQtyDate ? (
                          <input
                            type="text"
                            className="form-control form-rounded"
                            id="shippedqty"
                            value={rowEdit.ShippedQty || ""}
                            placeholder="Qty"
                            onChange={(e) => {
                              handleQtyChange(val.PO_NO, val.PART_NO, e.target.value);
                            }}
                          />
                        ) : (
                          val.QTY_SHIPPED || '-'
                        )}
                      </td>
                      <td id="comment" style={{ minWidth: '160px' }}>
                        {canEditComments ? (
                          isCommentEditing ? (
                            <textarea
                              className="form-control form-rounded"
                              style={{ width: '100%', minHeight: '48px', resize: 'vertical' }}
                              value={commentEdit !== undefined ? commentEdit : (val.COMMENTS || "")}
                              onChange={(e) => {
                                handleCommentChange(val.PO_NO, val.PART_NO, e.target.value);
                              }}
                              onFocus={() => setFocusedCommentRow(rowKey)}
                              onMouseLeave={() => {
                                if (focusedCommentRow !== rowKey) {
                                  setHoveredCommentRow(null);
                                }
                              }}
                              onBlur={() => {
                                UpdateComment(val);
                                setFocusedCommentRow(null);
                                setHoveredCommentRow(null);
                              }}
                            />
                          ) : (
                            <div
                              onMouseEnter={() => setHoveredCommentRow(rowKey)}
                              style={{ whiteSpace: 'pre-wrap', cursor: 'text', minHeight: '20px' }}
                            >
                              {val.COMMENTS || <span style={{ color: '#999' }}>-</span>}
                            </div>
                          )
                        ) : (
                          <div style={{ whiteSpace: 'pre-wrap' }}>{val.COMMENTS}</div>
                        )}
                      </td>
                      <td>
                        {canEditQtyDate ? (
                          <button class="btn btn-success" onClick={() => { Update(val) }}>Update</button>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{canEditQtyDate ? (
                        <button class="btn btn-danger" onClick={() => { window.confirm('Are you sure you want to delete this Entry ' + val.PART_NO + '?',) && Delete((val.PO_NO), (val.PART_NO)) }}> Delete</button>) : (
                        '-'
                      )}</td>
                    </tr>
                  </tbody>
                )
              })
            }
          </table>
        </div>
        <table class="table table-bordered" id="alldata" hidden>
          <thead>
            <tr>
              <th>PO NO</th>
              <th>PART NO</th>
              <th>PO SHIP DATE</th>
              <th>PART DESCRIPTION</th>
              <th>CUSTOMER</th>
              <th>PO QTY</th>
              <th>REMAINED QTY</th>
              <th>COMMENTS</th>
            </tr>
          </thead>

          {
            postList.map((val, key) => {
              return (
                <tbody>
                  <tr key={key}>
                    <td>{val.PO_NO}</td>
                    <td>{val.PART_NO}</td>
                    <td>{(val.PO_SHIP_DATE).slice(0, 10)}</td>
                    <td>{val.PART_DESCRIPTION}</td>
                    <td>{val.CUSTOMER}</td>
                    <td>{val.QTY}</td>
                    <td>{val.Remained_parts}</td>
                    <td>{val.COMMENTS}</td>

                  </tr>
                </tbody>
              )
            })
          }
        </table>
      </div>
    </div >
  )
}

export default ShippingData